import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { cn } from "@tellescope/utils";
import { GripVertical } from "lucide-react";

export interface SortableRankingItemProps {
  item: string;
}

export const SortableRankingItem = ({ item }: SortableRankingItemProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: item });

  return (
    <div
      ref={setNodeRef}
      style={{ transform: CSS.Transform.toString(transform), transition }}
      className={cn(
        "flex items-center gap-2 p-3 border rounded-md bg-background touch-none",
        isDragging ? "opacity-50 cursor-grabbing z-50" : "cursor-grab"
      )}
      {...attributes}
      {...listeners}
    >
      <div className="flex justify-center p-1 rounded">
        <GripVertical className="h-4 w-4 text-muted-foreground" />
      </div>
      <span className="text-sm select-none">{item}</span>
    </div>
  );
};
